module.exports = __webpack_public_path__ + "static/media/addToAppleWallet.0b5b9bd4.svg";